import React from "react";
import "./BrandsHeader.scss";

const BrandsHeader = ({ history, logo, back }) => {
  return (
    <div className="brands_header">
      <div
        className="brands_header_back"
        onClick={(e) => history.push(back)}
      ></div>
      <img src={logo} alt={logo} />
      <div
        className="brands_header_filters"
        onClick={(e) => history.push(back)}
      ></div>
    </div>
  );
};
export default BrandsHeader;
